import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {
  @Input() breadcrumbs: Breadcrumb[];

  constructor(private titleService: Title) {
  }

  public getBreadcrumbUrl(index: number) {
    if (!this.breadcrumbs || index < 0 || index >= this.breadcrumbs.length)
      return "";
    return this.breadcrumbs[index].URL;
  }

  ngOnInit() {
  }
}
